
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { VaFullscreenLightboxService } from '@vendasta/uikit';
import { File } from '../../files/shared/file.model';
import { Product } from '../../shared/product';
@Component({
  selector: 'store-screenshots-files',
  templateUrl: './screenshots-files.component.html',
  styleUrls: ['./screenshots-files.component.scss'],
  imports: [MatCardModule, MatIconModule],
  providers: [VaFullscreenLightboxService],
})
export class ScreenshotsFilesComponent {
  @Input() app: Product;
  @Input() clickable = true;

  constructor(private readonly lightbox: VaFullscreenLightboxService) {}

  getSrcsetImageUrls(imageUrl: string): string {
    return `${imageUrl}=s640 640w, ${imageUrl}=s1280 1280w, ${imageUrl}=s1920 1920w`;
  }

  onClick(index: number): void {
    if (this.clickable && this.app && this.app.screenshotUrls) {
      this.lightbox.open({ imageUrls: this.app.screenshotUrls, index: index });
    }
  }
  getFileName(fileUrl: File): string {
    if (fileUrl && fileUrl.url) {
      const filename = fileUrl.url.substring(fileUrl.url.lastIndexOf('/') + 1);
      return filename;
    }
    return '';
  }
}
